import React, { useRef, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ApiService } from "../../Components/Services/apiservices";
import { validNumber } from "../../Components/Elements/Regex";
import { Image } from "react-bootstrap";
import modal_logo from "../../images/modal_logo.png";
import border_spin from "../../images/border_spin.svg";
import mid_point from "../../images/mid_point.svg";

function Spinner() {
  const canvasRef = useRef(null);
  const location = useLocation();

  const [isSpinning, setIsSpinning] = useState(false);
  const [angle, setAngle] = useState(0);
  const [winningOffer, setWinningOffer] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [copied, setCopied] = useState(false);
  const [couponsList, setCouponsList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [contactDetails, setContactDetails] = useState({
    coupen_lead_name: "",
    coupen_mobile: "",
    coupen_id: "",
  });
  const size = 320;
  const center = size / 2;

  // ✅ Fetch coupons list on mount
  useEffect(() => {
    if (location.pathname == "/" && !sessionStorage.getItem("spinnerShown")) {
      ApiService.fetchData("spin-coupons-list")
        .then((res) => {
          if (res.status == "success") {
            const apiCoupons = res.resCouponsData || [];
            setCouponsList([
              ...apiCoupons,
              { spin_name: "Better Luck Next Time", promo_coupon_code: "" },
            ]);
          }
        })
        .catch((error) => {
          console.error("Error fetching coupons:", error);
        });

      const modal = new window.bootstrap.Modal(
        document.getElementById("exampleModal")
      );
      modal.show();

      sessionStorage.setItem("spinnerShown", "true");
    }
  }, [location.pathname]);

  const totalSlices = couponsList.length;
  const arcSize = (2 * Math.PI) / (totalSlices || 1);

  // ✅ Draw wheel dynamically
  useEffect(() => {
    if (!couponsList.length) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, size, size);

    const colors = ["#f9dcc4", "#f8edeb"];

    for (let i = 0; i < totalSlices; i++) {
      const startAngle = angle + i * arcSize;
      const endAngle = startAngle + arcSize;

      ctx.beginPath();
      ctx.moveTo(center, center);
      ctx.arc(center, center, center, startAngle, endAngle);
      ctx.fillStyle = colors[i % colors.length];
      ctx.fill();
      ctx.stroke();

      let text = couponsList[i]?.spin_name || "";
      let lines = [];

      if (text.length > 15) {
        let splitIndex = text.lastIndexOf(" ", 15);
        if (splitIndex == -1) splitIndex = 15;
        lines.push(text.slice(0, splitIndex));
        lines.push(text.slice(splitIndex).trim());
      } else {
        lines.push(text);
      }

      ctx.save();
      ctx.translate(center, center);
      ctx.rotate(startAngle + arcSize / 2);
      ctx.textAlign = "right";
      ctx.fillStyle = "#000";
      ctx.font = "14px sans-serif";

      if (lines.length == 1) {
        ctx.fillText(lines[0], center - 20, 5);
      } else {
        ctx.fillText(lines[0], center - 20, -2);
        ctx.fillText(lines[1], center - 20, 14);
      }

      ctx.restore();
    }
  }, [angle, couponsList]);

  // ✅ Spin Logic
 // ✅ Spin Logic
const spinWheel = () => {
  if (isSpinning || !couponsList.length) return;

  setIsSpinning(true); // disable button immediately

  const targetIndex = Math.floor(Math.random() * totalSlices);
  const anglePerSlice = (2 * Math.PI) / totalSlices;
  const spins = 6;

  const targetAngle = (totalSlices - targetIndex - 0.5) * anglePerSlice;
  const totalRotation = spins * 2 * Math.PI + targetAngle;
  const duration = 5000;
  const startTime = performance.now();

  const animate = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easeOut = 1 - Math.pow(1 - progress, 3);
    const newAngle = totalRotation * easeOut;
    setAngle(newAngle);

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      setIsSpinning(false); // enable again after spin finishes

      const prize = couponsList[targetIndex];
      setWinningOffer(prize?.spin_name || "");
      setCouponCode(prize?.promo_coupon_code || "");
      setContactDetails((prev) => ({
        ...prev,
        coupen_id: prize?.promo_id || "",
      }));

      // ❌ Removed setTimeout
      // ✅ Show winModal immediately after spin
      const exampleModalEl = document.getElementById("exampleModal");
      const exampleModal = window.bootstrap.Modal.getInstance(exampleModalEl);
      if (exampleModal) exampleModal.hide();

      const winModal = new window.bootstrap.Modal(
        document.getElementById("winModal")
      );
      winModal.show();
    }
  };

  requestAnimationFrame(animate);
};


  const copyToClipboard = () => {
    if (couponCode) {
      navigator.clipboard.writeText(couponCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const resetContactForm = () => {
    setContactDetails({
      coupen_lead_name: "",
      coupen_mobile: "",
      coupen_id: "",
    });
  };
  const submitspincoupen = () => {
    let counter = 0;
    const myElements = document.getElementsByClassName("required");
    for (let i = 0; i < myElements.length; i++) {
      if (myElements[i].value == "") {
        myElements[i].style.border = "1px solid red";
        counter++;
      } else {
        myElements[i].style.border = "";
      }
    }

    if (counter == 0) {
      setErrorMessage("");

      if (!validNumber.test(contactDetails.coupen_mobile)) {
        setErrorMessage("Please enter valid Mobile Number");
        return false;
      }

      ApiService.postData("submitspincoupen", contactDetails).then((res) => {
        if (res.status == "success") {
          setSuccessMessage(res.message);
          resetContactForm();
          setIsSubmitted(true);

          setTimeout(() => {
            setSuccessMessage("");
          }, 2000);

          // ✅ Close winModal and open copyModal
          const winModalEl = document.getElementById("winModal");
          const winModal = window.bootstrap.Modal.getInstance(winModalEl);
          if (winModal) {
            winModal.hide();
          }

          const copyModal = new window.bootstrap.Modal(
            document.getElementById("copyModal")
          );
          copyModal.show();
        } else {
          setErrorMessage(res.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 2000);
        }
      });
    }
  };

  return (
    <>
      {/* Spin Modal */}
      <div className="modal fade bg_color_m" id="exampleModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <button
              type="button"
              className="btn-close position-absolute"
              data-bs-dismiss="modal"
            ></button>
            <div className="modal-body py-4">
              <div className="spin_logo">
                {/* <img src="/img/logo.png" alt="" className="w-100" /> */}
                <Image src={modal_logo} className="w-100" />
              </div>
              <h5 className="text-center text-white">
                <b>Spin to win exclusive coupons</b>
              </h5>
              <div
                className="spin-wheel-wrapper mt-3 mb-4"
                style={{
                  position: "relative",
                  width: size,
                  height: size,
                  margin: "auto",
                }}
              >
                <Image
                  src={border_spin}
                  className="border_spin position-absolute"
                />
                <Image
                  src={mid_point}
                  className="mid_point position-absolute"
                />
                {/* Pointer */}
                <div className="pointer-icon-wrapper">
                  <svg
                    width="31"
                    height="30"
                    viewBox="0 0 31 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.4055 23.1703C28.5393 22.5985 29.8288 20.3918 28.9954 18.3459C27.4758 14.6152 25.2606 11.1934 22.4559 8.26856C19.6511 5.34376 16.3251 2.98726 12.6613 1.31276C10.652 0.394464 8.39332 1.59036 7.73272 3.69846L1.08512 24.9111C0.766317 25.9283 1.39332 26.99 2.13112 27.7594C2.86892 28.5288 3.90342 29.1997 4.93312 28.9238L26.4055 23.1703Z"
                      fill="url(#paint0_linear_1713_89)"
                      stroke="white"
                      strokeWidth="2"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_1713_89"
                        x1="21.987"
                        y1="7.78976"
                        x2="-0.640483"
                        y2="30.4172"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6F4B8D" />
                        <stop offset="1" stopColor="#6F4B8D" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <canvas
                  ref={canvasRef}
                  width={size}
                  height={size}
                  style={{ borderRadius: "50%", background: "#d97676" }}
                />
              </div>
              <div className="d-flex justify-content-center text-dark">
                <Link
                  to="#"
                  onClick={spinWheel}
                  disabled={isSpinning} // ✅ disables click
                  style={{
                    padding: "10px 20px",
                    background: isSpinning ? "#ccc" : "#fff", // greyed out when spinning
                    border: "0",
                    borderRadius: "10px",
                    cursor: isSpinning ? "not-allowed" : "pointer",
                    pointerEvents: isSpinning ? "none" : "auto", // extra safety
                  }}
                >
                  {isSpinning ? "Spinning..." : "Spin Now"}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Win Modal */}
      <div className="modal fade bg_color_m" id="winModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content text-center">
            <button
              type="button"
              className="btn-close ms-auto"
              data-bs-dismiss="modal"
            ></button>

            <div className="modal-body d-flex justify-content-between p-4">
              <div className="win_modal_left flex-fill d-flex align-items-center justify-content-center">
                <div className="position-relative">
                  <svg
                    width="222"
                    height="122"
                    viewBox="0 0 222 122"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.07273 0H43.391C43.9483 0 44.394 0.453607 44.4571 1.00726C44.9575 5.39606 48.6839 8.80536 53.2066 8.80536C57.7293 8.80536 61.4558 5.39606 61.9561 1.00726C62.0192 0.453607 62.4649 0 63.0222 0H213.927C218.385 0 222 3.61428 222 8.07273V113.018C222 117.476 218.385 121.091 213.927 121.091H62.0512L62.0499 121.09C62.0499 116.226 58.1071 112.283 53.2433 112.283C48.3796 112.283 44.4367 116.226 44.4367 121.09L44.4354 121.091H8.07274C3.61429 121.091 0 117.476 0 113.018V8.07273C0 3.61428 3.61428 0 8.07273 0Z"
                      fill="#F5F5DC"
                    />
                  </svg>
                  <div
                    className="position-absolute top-50 start-50 translate-middle text-dark"
                    style={{ width: "100%" }}
                  >
                    <h6 className="mb-1">You Won</h6>
                    <h5 className="fw-bold">{winningOffer}</h5>
                    <small>T&C Apply</small>
                  </div>
                </div>
              </div>
              {/* Show form before submit */}
              {!isSubmitted && (
                <div className="sp_login_form border rounded-4">
                  <h4 className="mb-2 text-white">Woah! What a Win</h4>
                  <h6 className="mb-3 text-white">{winningOffer}</h6>
                  <form>
                    <input
                      type="text"
                      className="form-control mb-2 required"
                      placeholder="Name"
                      value={contactDetails.coupen_lead_name}
                      onChange={(e) =>
                        setContactDetails({
                          ...contactDetails,
                          coupen_lead_name: e.target.value,
                        })
                      }
                    />
                    <input
                      type="tel"
                      className="form-control mb-2 required"
                      placeholder="Mobile Number"
                      value={contactDetails.coupen_mobile}
                      onChange={(e) =>
                        setContactDetails({
                          ...contactDetails,
                          coupen_mobile: e.target.value,
                        })
                      }
                    />
                    <div className="form-check mt-2 mb-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="checkDefault"
                      />
                      <label
                        className="form-check-label w-100 text-start"
                        htmlFor="checkDefault"
                        style={{ color: "white" }}
                      >
                        Notify me for offers & updates
                      </label>
                    </div>
                    <div className="d-flex justify-content-center text-dark">
                      <Link
                        to="#"
                        onClick={submitspincoupen}
                        style={{
                          padding: "6px 20px",
                          background: "#fff",
                          border: "0",
                          borderRadius: "10px",
                          cursor: "pointer",
                          width: "150px",
                          marginTop: "20px",
                        }}
                      >
                        Submit
                      </Link>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade bg_color_m" id="copyModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content text-center">
            <button
              type="button"
              className="btn-close ms-auto"
              data-bs-dismiss="modal"
            ></button>

            <div className="modal-body">
              <div className="win_modal_left flex-fill d-flex align-items-center justify-content-center">
                <div className="position-relative">
                  <svg
                    width="222"
                    height="122"
                    viewBox="0 0 222 122"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.07273 0H43.391C43.9483 0 44.394 0.453607 44.4571 1.00726C44.9575 5.39606 48.6839 8.80536 53.2066 8.80536C57.7293 8.80536 61.4558 5.39606 61.9561 1.00726C62.0192 0.453607 62.4649 0 63.0222 0H213.927C218.385 0 222 3.61428 222 8.07273V113.018C222 117.476 218.385 121.091 213.927 121.091H62.0512L62.0499 121.09C62.0499 116.226 58.1071 112.283 53.2433 112.283C48.3796 112.283 44.4367 116.226 44.4367 121.09L44.4354 121.091H8.07274C3.61429 121.091 0 117.476 0 113.018V8.07273C0 3.61428 3.61428 0 8.07273 0Z"
                      fill="#F5F5DC"
                    />
                  </svg>
                  <div
                    className="position-absolute top-50 start-50 translate-middle text-dark"
                    style={{ width: "100%" }}
                  >
                    <h6 className="mb-1">You Won</h6>
                    <h5 className="fw-bold">{winningOffer}</h5>
                    <small>T&C Apply</small>
                  </div>
                </div>
              </div>
              {/* After submit - Winner */}
              {isSubmitted && couponCode && (
                <div>
                  <div className="d-flex justify-content-center align-items-center mt-4 gap-2">
                    <span className="fw-bold px-3 py-1 border rounded text-white">
                      {couponCode}
                    </span>
                    <button
                      className="btn btn-sm btn-outline-light"
                      onClick={copyToClipboard}
                    >
                      Copy
                    </button>
                  </div>
                  {copied && (
                    <small className="d-block mt-2 text-success">
                      Copied to clipboard!
                    </small>
                  )}
                  <h6 className="mt-3 text-white">🎉 Offer Unlocked</h6>
                  <p className="mb-0 text-white">Happy Shopping</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* After submit - No coupon */}
      {isSubmitted && !couponCode && (
        <div>
          <h4 className="mb-3 text-danger">😢 Better luck next time!</h4>
          <p className="mb-0 text-white">Don’t worry, try spinning again!</p>
        </div>
      )}
    </>
  );
}

export default Spinner;
